<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit Agency Member
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.agency_name"
                disabled
                outlined
                label="Agency Name"
                prepend-inner-icon="mdi-domain"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.agency_id"
                disabled
                outlined
                label="Agency ID"
                prepend-inner-icon="mdi-domain"
              ></v-text-field>
            </v-col>

            <v-col sm="6">
              <v-text-field
                v-model="form.user_id"
                outlined
                label="User ID"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>

            <!-- <v-col sm="6">
              <v-text-field
                v-model="form.performance_score"
                outlined
                label="Performance Score"
                type="number"
                prepend-inner-icon="mdi-star"
              ></v-text-field>
            </v-col>

            <v-col sm="6">
              <v-text-field
                v-model="form.rewards_given"
                outlined
                label="Rewards Given (₹)"
                type="number"
                prepend-inner-icon="mdi-currency-inr"
              ></v-text-field>
            </v-col> -->
          </v-row>

          <v-divider class="my-5"> </v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="update"
          >
            Update Member
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "AgencyMemberEditPage",
  data() {
    return {
      filter: {
        search_keyword: "",
      },
      form: {
        agency_name: "",
        agency_id: "",
        user_id: "",
      },
      agencies: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        this.isLoading = true;
        let id = this.$route.params.agencyMemberId;
        let response = await axios.get(`/agency_members/${id}`);
        this.form = response.data.data;
        this.isLoading = false;
      } catch (error) {
        console.error("Error loading member:", error);
        this.isLoading = false;
      }
    },
    async update() {
      try {
        this.isLoading = true;
        let id = this.$route.params.agencyMemberId;
        await axios.patch(`/agency_members/${id}`, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (error) {
        console.error("Error updating member:", error);
        this.isLoading = false;
      }
    },
  },
};
</script>
